<template>
	<!-- Persistent and without a cancel action on purpose: the route the user asked for cannot
	     load, so there is nothing to return to. -->
	<v-dialog v-model="reloadRequired" max-width="440" persistent>
		<v-card class="app-update-required">
			<v-card-title>Update required</v-card-title>

			<v-divider />

			<v-card-text class="pa-6">
				<v-alert type="info" variant="tonal">
					<div class="text-body-1">
						A new version of the portal has been released and this page is out of date.
						Reload to continue.
					</div>
				</v-alert>
			</v-card-text>

			<v-divider />

			<v-card-actions class="pa-4">
				<v-spacer />
				<v-btn color="primary" class="btn-legacy-save" @click="reload">Reload</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { useAppUpdate } from '@/composables/useAppUpdate'

const { reloadRequired, reload } = useAppUpdate()
</script>

<style scoped>
@import './AppUpdateRequired.css';
</style>
